import { noop } from 'vtils'
import {
  onActivated,
  onBeforeUnmount,
  onDeactivated,
  onMounted,
  ref,
} from '@vue/composition-api'

export function useActivated(cb: () => any) {
  const dispose = ref()

  onMounted(() => {
    setTimeout(() => {
      // 没有执行 onActivated
      if (!dispose.value) {
        dispose.value = cb() ?? noop
      }
    }, 0)
  })

  onBeforeUnmount(async () => {
    ;(await dispose.value)?.()
    dispose.value = undefined
  })

  onActivated(() => {
    dispose.value = cb() ?? noop
  })

  onDeactivated(async () => {
    ;(await dispose.value)?.()
    dispose.value = undefined
  })
}
